import styled from 'styled-components';

export const TopicsEachSection = styled.div`
  border-radius: 23px;
  border: none;
  padding: 10px;
  margin: 8px 0px;
  font-size: clamp(14px, 2vw, 15px);
  font-weight: 500;
  color: rgba(0, 0, 0, 0.8);
  width: max-content;
  transition: all 0.2s ease-in-out 0s;
  display: flex;
  align-items: center;
  background-color: ${(props) => props.bg};
`;

export const QNATopicList = styled.div`
  display: flex;
  flex-wrap: wrap;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: start;
  justify-content: flex-start;
  padding: 10px 0px;
  column-gap: 3%;
`;
